const initialState = []


export default function cart(state=initialState, action){
  let cartList = [...state]

  switch (action.type) {

    case 'REDUCE_QUANTITY':
      let reduceObjIndex = cartList.findIndex((obj => (obj.product_id === action.product_id && obj.month === action.month)));
      if (cartList[reduceObjIndex] == null){
        console.log("Can't do that")
      } else {
        if (cartList[reduceObjIndex].quantity < 2) {
          cartList.splice(reduceObjIndex,1);
        } else {
          cartList[reduceObjIndex].quantity -= 1
        }
      }
      return cartList

    case 'ADD_QUANTITY':
      let addObjIndex = cartList.findIndex((obj => obj.product_id === action.detailId && obj.month === action.month));
      cartList[addObjIndex].quantity += 1
      return cartList

    case 'ADD_TO_CART':
      let addToObjIndex = cartList.findIndex((obj => (obj.product_id === action.product.id && obj.month === action.month)));
      if (addToObjIndex === -1) {
        let newToObj =
          {
            month: action.month,
            product_id: action.product.id,
            product_title: action.product.title,
            product_price: action.product.price,
            quantity: 1,
          }
        cartList = [...cartList, newToObj]
      } else {
        cartList[addToObjIndex].quantity += 1
      }
      return cartList

    case 'GET_CART':
      return action.data.cart

    case 'CLEAR_CART':
      return []

    default:
      return state;


  }
}



// WEBPACK FOOTER //
// ./src/reducers/cart.js